export const createMetadata = () => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        const firebase = getFirebase()
        var createMetadataFunc = await firebase.functions().httpsCallable('createFishMetadata');
        await createMetadataFunc()
        .catch((error) => {
            console.error(error)
        })
    }
}